/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PriceFeedDispatcher,
  PriceFeedDispatcherInterface,
} from "../PriceFeedDispatcher";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "chainlinkPriceFeedV3",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum IPriceFeedDispatcherEvent.Status",
        name: "status",
        type: "uint8",
      },
    ],
    name: "StatusUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "uniswapV3PriceFeed",
        type: "address",
      },
    ],
    name: "UniswapV3PriceFeedUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "dispatchPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getChainlinkPriceFeedV3",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "interval",
        type: "uint256",
      },
    ],
    name: "getDispatchedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getUniswapV3PriceFeed",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isToUseUniswapV3PriceFeed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "uniswapV3PriceFeed",
        type: "address",
      },
    ],
    name: "setUniswapV3PriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PriceFeedDispatcher__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    chainlinkPriceFeedV3: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PriceFeedDispatcher> {
    return super.deploy(
      chainlinkPriceFeedV3,
      overrides || {}
    ) as Promise<PriceFeedDispatcher>;
  }
  getDeployTransaction(
    chainlinkPriceFeedV3: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(chainlinkPriceFeedV3, overrides || {});
  }
  attach(address: string): PriceFeedDispatcher {
    return super.attach(address) as PriceFeedDispatcher;
  }
  connect(signer: Signer): PriceFeedDispatcher__factory {
    return super.connect(signer) as PriceFeedDispatcher__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PriceFeedDispatcherInterface {
    return new utils.Interface(_abi) as PriceFeedDispatcherInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceFeedDispatcher {
    return new Contract(address, _abi, signerOrProvider) as PriceFeedDispatcher;
  }
}
